import request from '@/utils/request'

export function queryPayResult(query) {
  return request({
    url: '/index/pay/queryPayResult',
    method: 'post',
    data: query
  })
}

export function queryPayState(query) {
  return request({
    url: '/index/pay/queryPayState',
    method: 'post',
    params: query
  })
}


